<template>
  <div class="row workorder chat-width">
    <div class="last-col">
      <div class="table-responsive">
        <table ref="chatTable" class="maintable smaller">
          <thead>
            <tr>
              <th>!</th>
              <th>{{ $t("PACIENT") }}</th>
              <th>{{ $t("FROM") }}</th>
              <th class="d-none d-md-table-cell">{{ $t("TO") }}</th>
              <th>{{ $t("TIME") }}</th>
              <th>{{ $t("MESSAGE") }}</th>
              <th class="d-none d-md-table-cell center">
                {{ $t("WORKFORM") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="talk in talks.root"
              :key="talk.workOrderTalkId"
              v-bind:class="{
                read: talk.unread == 0,
                to_respond: talk.chatUserId !== talk.toUserId,
              }"
              v-on:click.prevent="startChat(talk)"
            >
              <td class="notification"><div></div></td>
              <td>{{ getDesc(talk) }}</td>
              <td>{{ talk.name }} {{ talk.surname }}</td>
              <td class="d-none d-md-table-cell">
                {{ talk.toName }} {{ talk.toSurname }}
              </td>
              <td>{{ formatDate(talk.dateTime) }}</td>
              <td>{{ talk.text }}</td>
              <td class="d-none d-md-table-cell center">
                <router-link
                  v-if="talk.workOrderId"
                  :to="{
                    path: '/workorders/' + talk.workOrderId,
                    query: { open: 'chat' },
                  }"
                  ><img src="../assets/img/icon-nalog-blue.svg"
                /></router-link>
                <router-link
                  v-if="talk.dentalSolutionId"
                  :to="{
                    path: '/dentalsolutions/' + talk.dentalSolutionId,
                    query: { open: 'chat' },
                  }"
                  ><img src="../assets/img/icon-nalog-blue.svg"
                /></router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-pagination
        align="center"
        v-if="talks.totalCount > 20"
        :total-rows="talks.totalCount"
        v-model="pagination.currentPage"
        :per-page="pagination.limit"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import workOrderTalksApi from "@/api/workordertalks";

export default {
  name: "Talks",
  data: function () {
    return {
      talks: {},
      pagination: {
        query: "",
        currentPage: 1,
        limit: 20,
      },
    };
  },
  created: function () {
    var me = this;
    me.getTalks();
  },
  methods: {
    getDesc(talk) {
      if (talk.patientName != null) {
        return talk.patientName + " " + talk.patientSurname;
      }
      return talk.dentalSolutionId;
    },
    startChat(talk) {
      const me = this;

      me.chatUserId = talk.chatUserId;

      setTimeout(() => {
        if (talk.workOrderId != null) {
          this.$store.commit("setChatData", {
            chatUserId: talk.chatUserId,
            workOrderId: talk.workOrderId,
          });
        } else {
          this.$store.commit("setChatData", {
            chatUserId: talk.chatUserId,
            dentalSolutionId: talk.dentalSolutionId,
          });
        }
      }, 0);
    },
    getTalks: function () {
      var me = this;
      me.tasks = {};
      workOrderTalksApi.selectMyChats(me.getParams, function (data) {
        if (data.error && data.error == true) {
          me.$notify.error(data.notice);
          return;
        }

        me.talks = data;
      });
    },
  },
  watch: {
    "pagination.query": function () {
      var me = this;
      me.getTalks();
    },
    "pagination.currentPage": function (val) {
      var me = this;
      me.getTalks();
      me.$refs.chatTable.scrollIntoView(true);
    },
  },
  computed: {
    getParams: function () {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ProfileChat.vue